export default {"src":"/_next/static/media/wave-quote.dda37131.svg","height":302,"width":1446,"blurWidth":0,"blurHeight":0};